import { FC, SVGAttributes } from "react";

const AmexIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>American Express</title>
    <path
      d="M29 1H5C2.79086 1 1 2.79086 1 5V21C1 23.2091 2.79086 25 5 25H29C31.2091 25 33 23.2091 33 21V5C33 2.79086 31.2091 1 29 1Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.8201 13.8935L29.1767 15.275L29.1975 15.2922C29.437 15.5008 29.5761 15.804 29.5908 16.1672L29.5921 16.232C29.5921 17.002 29.0659 17.5669 28.242 17.5669H26.3238V17.5651H20.474L20.004 16.9866V17.5651H18.4636V16.5775C18.4636 16.5775 18.2532 16.7154 17.7983 16.7154H17.274V17.5651H14.9418L14.5255 17.0099L14.1028 17.5651H10.2412V13.895H14.1271L14.5441 14.4385L14.9748 13.895H27.6807C27.7096 13.894 27.7389 13.8935 27.7686 13.8935H29.8201Z"
      fill="white"
    />
    <path
      d="M6.57936 9.08655H8.09481L8.59211 10.2309V9.08655H10.476L10.772 9.91367L11.059 9.08655H19.5155V9.50237C19.5155 9.50237 19.9601 9.08655 20.6907 9.08655L23.4345 9.09614L23.9232 10.2255V9.08655H25.4997L25.9336 9.7353V9.08655H27.5246V12.7566H25.9336L25.5178 12.1058V12.7566H23.2016L22.9686 12.1781H22.346L22.1168 12.7566H20.546C19.9174 12.7566 19.5155 12.3493 19.5155 12.3493V12.7566H17.1472L16.6771 12.1781V12.7566H7.8703L7.63753 12.1781H7.01684L6.78572 12.7566H5.00003L6.57936 9.08655Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.70774 12.2871L6.88966 9.53911H7.78571L8.96651 12.2871H8.18006L7.96311 11.7369H6.69531L6.47723 12.2871H5.70774ZM7.71321 11.1402L7.32676 10.1786L6.93919 11.1402H7.71321Z"
      fill="#016FD0"
    />
    <path
      d="M9.04763 12.2864V9.53841L10.1411 9.54247L10.7771 11.3142L11.3979 9.53841H12.4827V12.2864H11.7957V10.2616L11.0674 12.2864H10.4649L9.73464 10.2616V12.2864H9.04763Z"
      fill="#016FD0"
    />
    <path
      d="M12.9523 12.2864V9.53841H15.1941V10.1531H13.6465V10.6232H15.1579V11.2017H13.6465V11.6898H15.1941V12.2864H12.9523Z"
      fill="#016FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.5921 12.2871V9.53911H17.1209C17.6275 9.53911 18.0813 9.85236 18.0813 10.4306C18.0813 10.925 17.6987 11.2434 17.3277 11.2747L18.2316 12.2871H17.3921L16.5683 11.3109H16.2791V12.2871H15.5921ZM17.0642 10.1536H16.2789V10.7321H17.0744C17.2121 10.7321 17.3897 10.6254 17.3897 10.4428C17.3897 10.3009 17.2526 10.1536 17.0642 10.1536Z"
      fill="#016FD0"
    />
    <path
      d="M19.0633 12.2864H18.3619V9.53841H19.0633V12.2864Z"
      fill="#016FD0"
    />
    <path
      d="M20.7268 12.2864H20.5754C19.8428 12.2864 19.398 11.7093 19.398 10.9237C19.398 10.1188 19.8378 9.53841 20.763 9.53841H21.5223V10.1893H20.7352C20.3596 10.1893 20.094 10.4823 20.094 10.9305C20.094 11.4627 20.3977 11.6862 20.8353 11.6862H21.0161L20.7268 12.2864Z"
      fill="#016FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0396 12.2871L22.2215 9.53911H23.1175L24.2983 12.2871H23.5119L23.2949 11.7369H22.0271L21.8091 12.2871H21.0396ZM23.0453 11.1402L22.6589 10.1786L22.2713 11.1402H23.0453Z"
      fill="#016FD0"
    />
    <path
      d="M24.3787 12.2864V9.53841H25.2521L26.3674 11.265V9.53841H27.0544V12.2864H26.2092L25.0657 10.5147V12.2864H24.3787Z"
      fill="#016FD0"
    />
    <path
      d="M10.7103 17.0957V14.3477H12.9521V14.9623H11.4046V15.4324H12.916V16.0109H11.4046V16.4991H12.9521V17.0957H10.7103Z"
      fill="#016FD0"
    />
    <path
      d="M21.6956 17.0957V14.3477H23.9375V14.9623H22.3899V15.4324H23.8941V16.0109H22.3899V16.4991H23.9375V17.0957H21.6956Z"
      fill="#016FD0"
    />
    <path
      d="M13.0403 17.0957L14.1319 15.7386L13.0143 14.3477H13.8799L14.5454 15.2075L15.2132 14.3477H16.0449L14.942 15.7217L16.0356 17.0957H15.1702L14.5239 16.2494L13.8934 17.0957H13.0403Z"
      fill="#016FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1169 17.0961V14.348H17.6344C18.2571 14.348 18.6208 14.7493 18.6208 15.2723C18.6208 15.9036 18.157 16.2283 17.5451 16.2283H16.822V17.0961H16.1169ZM17.5833 14.9694H16.8217V15.6022H17.581C17.7817 15.6022 17.9223 15.4692 17.9223 15.2858C17.9223 15.0905 17.781 14.9694 17.5833 14.9694Z"
      fill="#016FD0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.9187 17.0957V14.3477H20.4475C20.9541 14.3477 21.408 14.6609 21.408 15.2392C21.408 15.7335 21.0253 16.0519 20.6543 16.0833L21.5583 17.0957H20.7187L19.895 16.1194H19.6057V17.0957H18.9187ZM20.3911 14.9623H19.6058V15.5409H20.4013C20.539 15.5409 20.7166 15.4342 20.7166 15.2516C20.7166 15.1097 20.5795 14.9623 20.3911 14.9623Z"
      fill="#016FD0"
    />
    <path
      d="M24.2556 17.0957V16.4991H25.6305C25.8339 16.4991 25.922 16.3891 25.922 16.2686C25.922 16.153 25.8342 16.0362 25.6305 16.0362H25.0092C24.4691 16.0362 24.1683 15.7072 24.1683 15.2132C24.1683 14.7726 24.4438 14.3477 25.2463 14.3477H26.5841L26.2949 14.966H25.1378C24.9166 14.966 24.8485 15.082 24.8485 15.1929C24.8485 15.3068 24.9327 15.4324 25.1017 15.4324H25.7525C26.3545 15.4324 26.6158 15.7739 26.6158 16.2211C26.6158 16.7019 26.3247 17.0957 25.7197 17.0957H24.2556Z"
      fill="#016FD0"
    />
    <path
      d="M26.7778 17.0957V16.4991H28.1527C28.3562 16.4991 28.4443 16.3891 28.4443 16.2686C28.4443 16.153 28.3565 16.0362 28.1527 16.0362H27.5314C26.9914 16.0362 26.6906 15.7072 26.6906 15.2132C26.6906 14.7726 26.966 14.3477 27.7686 14.3477H29.1064L28.8172 14.966H27.6601C27.4389 14.966 27.3708 15.082 27.3708 15.1929C27.3708 15.3068 27.455 15.4324 27.6239 15.4324H28.2748C28.8768 15.4324 29.1381 15.7739 29.1381 16.2211C29.1381 16.7019 28.847 17.0957 28.242 17.0957H26.7778Z"
      fill="#016FD0"
    />
  </svg>
);

export default AmexIconBackground;
